import React from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import map from 'lodash/map'
import { t } from '../../i18n'
import Actions from './Actions'
import Status from './Status'
import { LocalizationContext, LocalizationContextType, DEFAULT_LOCALIZATION_CONTEXT } from '../shared/contexts'

const scope = 'controls'

interface Props {
  locationId: number
  kitchenConfigurationOptions: Record<string, { rows: number, columns: number }>
  localization_context?: LocalizationContextType
  canUpdate: boolean
  canUpdateLocation: boolean
}

const STATUS_TAB_KEY = 2

const Controls = ({ locationId, kitchenConfigurationOptions, localization_context, canUpdate, canUpdateLocation }: Props) => {
  const [activeTabKey, setActiveTabKey] = React.useState(1)
  const [statusDirty, setStatusDirty] = React.useState(false)

  const handleTabChange = (key: string | null) => {
    const nextKey = Number(key)
    const leavingDirtyStatus = activeTabKey === STATUS_TAB_KEY && nextKey !== STATUS_TAB_KEY && statusDirty

    if (leavingDirtyStatus && !window.confirm(t('kitchen_config_discard_confirm', { scope }))) {
      return
    }

    setActiveTabKey(nextKey)
  }

  const tabs = [
    {
      title: t('actions', { scope }),
      component: <Actions canUpdate={canUpdate} />
    },
    {
      title: t('status', { scope }),
      component: (
        <Status
          locationId={locationId}
          kitchenConfigurationOptions={kitchenConfigurationOptions}
          canUpdateLocation={canUpdateLocation}
          onDirtyChange={setStatusDirty}
        />
      )
    }
  ]

  return (
    <LocalizationContext.Provider value={localization_context || DEFAULT_LOCALIZATION_CONTEXT}>
      <Tabs
        activeKey={activeTabKey}
        transition={false}
        mountOnEnter={true}
        unmountOnExit={true}
        onSelect={handleTabChange}
        fill={true}
        justify={true}
      >
        {map(tabs, (tab, index) => (
          <Tab
            key={`t${index + 1}`}
            eventKey={index + 1}
            title={tab.title}
            className="nav-tabs"
          >
            {tab.component}
          </Tab>
        ))}
      </Tabs>
    </LocalizationContext.Provider>
  )
}

export default Controls
